import { IShipUser } from "../../Types"

// Crew roster groupings for the ship_users tab, derived from the store-backed roster
// that `UsersDataView` acquires. Extracted verbatim from the former `ShipDataView` root
// derivation (issue #1186) so the sort order is unchanged.
export interface ShipUserGroups {
  // All crew, sorted by active → crew-role → name.
  sorted: IShipUser[];
  // Crew with a permission level (`shipUserLevel >= 1`), sorted by level first.
  leveled: IShipUser[];
  // Crew without a permission level (`shipUserLevel < 1`).
  unleveled: IShipUser[];
}

// Group + sort a crew roster. `undefined` (roster not yet loaded in the Legacy path)
// yields empty groups so callers can gate a `<Loading/>` on `shipUsers === undefined`
// separately from an empty-but-loaded roster.
export function groupShipUsers(shipUsers: IShipUser[] | undefined): ShipUserGroups {
  if (!shipUsers) {
    return { sorted: [], leveled: [], unleveled: [] };
  }
  const sorted = shipUsers.toSorted((a, b) => {
    if (b.active !== a.active) return b.active - a.active;
    if (b.shipUserCrewRole !== a.shipUserCrewRole) return b.shipUserCrewRole - a.shipUserCrewRole;
    return (a.name || "").localeCompare(b.name || "");
  });
  const leveled = sorted.filter((user) => user.shipUserLevel >= 1).sort((a, b) => {
    if (b.shipUserLevel !== a.shipUserLevel) return b.shipUserLevel - a.shipUserLevel;
    if (b.active !== a.active) return b.active - a.active;
    if (b.shipUserCrewRole !== a.shipUserCrewRole) return b.shipUserCrewRole - a.shipUserCrewRole;
    return (a.name || "").localeCompare(b.name || "");
  });
  const unleveled = sorted.filter((user) => user.shipUserLevel < 1).sort((a, b) => {
    if (b.active !== a.active) return b.active - a.active;
    if (b.shipUserCrewRole !== a.shipUserCrewRole) return b.shipUserCrewRole - a.shipUserCrewRole;
    return (a.name || "").localeCompare(b.name || "");
  });
  return { sorted, leveled, unleveled };
}
